import React from "react"
import { HeroContent } from "@/components/HeroContent"
import { HeroImage } from "@/components/HeroImage"

export function HeroSection() {
  return (
    <section className="w-full flex bg-gradient-to-b from-hero-end to-hero-start overflow-hidden max-lg:min-h-[auto] max-lg:flex-col-reverse max-lg:overflow-visible">
      <HeroContent />
      <HeroImage />
    </section>
  )
}
